import { Type, type Static } from "@sinclair/typebox";
import { TemporaryFileReferenceSchema } from "./document-platform.ts";

export const PRESENTATION_PREVIEW_TOOL_KEY = "render_presentation_preview" as const;
export const PRESENTATION_PREVIEW_PNG_MEDIA_TYPE = "image/png" as const;
export const PRESENTATION_PREVIEW_MAX_RENDERED_SLIDES = 40;

const SlideNumberSchema = Type.Integer({ minimum: 1, maximum: 200 });

export const RenderPresentationPreviewInputSchema = Type.Object(
  {
    source: TemporaryFileReferenceSchema,
    slide: Type.Optional(SlideNumberSchema),
    slides: Type.Optional(
      Type.Object(
        {
          from: SlideNumberSchema,
          to: SlideNumberSchema
        },
        { additionalProperties: false }
      )
    )
  },
  { additionalProperties: false }
);

export const RenderPresentationPreviewOutputSchema = Type.Object(
  {
    source: TemporaryFileReferenceSchema,
    output: Type.Object(
      {
        path: Type.String({
          minLength: 13,
          maxLength: 1_024,
          pattern: "^/tmp/output/[^/\\\\\\u0000-\\u001f\\u007f]+$"
        }),
        name: Type.String({
          minLength: 1,
          maxLength: 512,
          pattern: "^(?!\\.{1,2}$)[^/\\\\\\u0000-\\u001f\\u007f]+$"
        })
      },
      { additionalProperties: false }
    ),
    mediaType: Type.Literal(PRESENTATION_PREVIEW_PNG_MEDIA_TYPE),
    slideCount: Type.Integer({ minimum: 1, maximum: 200 }),
    renderedSlides: Type.Array(SlideNumberSchema, {
      minItems: 1,
      maxItems: PRESENTATION_PREVIEW_MAX_RENDERED_SLIDES,
      uniqueItems: true
    })
  },
  { additionalProperties: false }
);

export type RenderPresentationPreviewInputV1 = Static<typeof RenderPresentationPreviewInputSchema>;
export type RenderPresentationPreviewOutputV1 = Static<
  typeof RenderPresentationPreviewOutputSchema
>;
